import React from 'react';
import { AsyncSelect } from '@cx/ui';
import useDataDrivenFiltersOption, {
  UseDataDrivenFilterOptionProps,
} from '../hooks/useDataDrivenFiltersOption';

type DataDrivenFilterOptionProps = UseDataDrivenFilterOptionProps &
  React.HTMLAttributes<HTMLDivElement>;

/**
 * Renders the option selector for the enterprise filter.
 * @param param0
 * @returns
 */
function DataDrivenFiltersOption({
  className,
  selectedFilterIndex,
  selectedPartitionIndex,
}: DataDrivenFilterOptionProps) {
  const {
    options,
    selectedOptions,
    currentSelectedFilter,
    onOptionSelected,
    onLoadOptions,
  } = useDataDrivenFiltersOption({
    selectedFilterIndex,
    selectedPartitionIndex,
  });
  return (
    <div className={className}>
      <AsyncSelect
        name="enterprise-filter-option-selector"
        placeholder="Select an option"
        className="select"
        defaultOptions={options}
        options={options}
        value={selectedOptions || null}
        onChange={onOptionSelected}
        maxMenuHeight={250}
        closeMenuOnSelect={false}
        isLoading={currentSelectedFilter?.ui?.loading}
        isMulti
        autoload={false}
        loadOptions={onLoadOptions}
        debounceTimeout={300}
        cacheOptions
      />
    </div>
  );
}

export default DataDrivenFiltersOption;
